module.exports = __webpack_public_path__ + "logo.svg?be19e845c7dee9da14a6811e4a3e5658";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 21
// module chunks = 0